import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Form, Table, Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Paginator from "../../components/common/Pagination";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { formatDateDMY, formatTime } from "../../utils/Helper";
import { ToastContainer, toast } from "react-toastify";
import DeleteModal from "../../components/common/DeleteModel";
import Archive from "../../components/common/ArchiveModel";
import { capitalizeFirstLetter } from "../../utils/Helper";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';

const TodoList = () => {
  const [todoList, setTodoList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({
    from_date: moment().format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
  });
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const limit = 10;
  const navigate = useNavigate();
  const permissionscontext = useMenuPermissions("/admin/todo-list");
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedId, setSelectedId] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedRange, setSelectedRange] = useState("today");

  const handleDateRange = (range) => {
    const now = new Date();
    let start = null;
    let end = null;
  
    if (range === "disabled") {
      setFilters({
        from_date: null,
        to_date: null,
      });
      setSelectedRange("");
      return;
    }
  
    switch (range) {
      case "today":
        start = end = now;
        break;
      case "yesterday":
        start = end = new Date(now.setDate(now.getDate() - 1));
        break;
      case "thisWeek":
        start = new Date(now.setDate(now.getDate() - now.getDay()));
        end = new Date(new Date().setDate(start.getDate() + 6));
        break;
      case "last7Days":
        start = new Date(new Date().setDate(now.getDate() - 6));
        end = new Date();
        break;
      case "thisMonth":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case "lastMonth":
        start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        end = new Date(now.getFullYear(), now.getMonth(), 0);
        break;
      case "customDate":
        start = end = null;
        break;
      default:
        break;
    }
  
    setFilters({
      from_date: start ? moment(start).format("YYYY-MM-DD") : null,
      to_date: end ? moment(end).format("YYYY-MM-DD") : null,
    });
  
    setSelectedRange(range);
  }

  useEffect(() => {
    fetchTodoList(currentPage, filters);
  }, [currentPage, filters]);

  const fetchTodoList = async (page = 1, filters) => {
    const params = {
      offset: (page - 1) * limit,
      limit: limit,
      ...filters,
    };

    const queryString = Object.entries(params)
      .filter(
        ([_, value]) => value !== "" && value !== undefined && value !== null
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    try {
      const response = await APIServices.get(
        `/admin/to_do/list?${queryString}`,
        headers
      );
      if (response?.status === 200) {
        setTodoList(response?.data?.list || []);
        setCount(response?.data?.count);
        const totalItems = response?.data?.count || 0;
        setTotalCount(Math.ceil(totalItems / limit));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setTodoList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTodoList([]);
      setTotalCount(0);
    }
  };


  const handleDateChange = (e, type) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusChange = (userId) => {
    setSelectedIds((prev) => {
      if (prev.includes(userId)) {
        return prev.filter(id => id !== userId); // Remove
      } else {
        return [...prev, userId]; // Add
      }
    });
  };
 const handleStatusClickToComplete = async() => {

  if (selectedIds.length === 0) {
    showToast("Please select atleast one record" , "warning");
    return;
  }
  const ids = selectedIds.join(','); 
    try {
      const payload = { id: ids, status: "Complete"};
      const res = await APIServices.post(
        `/admin/to_do/status_update`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        fetchTodoList(currentPage, filters)
        setSelectedIds([])
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
};

const handleStatusCancel = async() => {
  try {
    const payload = { id: selectedId, status: "Cancelled"};
    const res = await APIServices.post(
      `/admin/to_do/status_update`,
      payload,
      headers
    );
    if (res?.data?.status === true) {
      showToast(res?.data?.message || "Success", "success");
      fetchTodoList(currentPage, filters)
      setSelectedIds([])
    } else {
      showToast(res?.data?.message || "Something went wrong.", "error");
    }
    setShow(false)
  } catch (error) {
    console.error("Error updating status:", error);
    showToast("Error updating status", "error");
  }

}
  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      {permissionscontext.view ? (
        <div className="todo_list_inner">
          <div className="todo_header d-flex align-items-center justify-content-between mb-3">
            <h1 className="font_blue_18 font-600">{`To Do List (${count})`}</h1>

            <ul className="d-flex align-items-center mom_filter gap-3">
              <li>
                <div className="d-flex align-items-center date_range">
              <div className="date-filter-container">
             <div className="filter-row">
               <div className="select-icon-wrapper">
                 <select
                   className="select-range"
                   value={selectedRange}
                   onChange={(e) => handleDateRange(e.target.value)}
                 >
                   {/* <option value="disabled">Select Date</option> */}
                   <option value="today">Today</option>
                   <option value="yesterday">Yesterday</option>
                   <option value="thisWeek">This Week</option>
                   <option value="last7Days">Last 7 Days</option>
                   <option value="thisMonth">This Month</option>
                   <option value="lastMonth">Last Month</option>
                   <option value="customDate">Custom Date</option>
                 </select>
                 <img src="/images/down-arrow.png" className="select-icon" alt="dropdown icon" />
               </div>
           
               {selectedRange === "customDate" && (
                 <DatePicker
                   selectsRange
                   startDate={filters.from_date ? new Date(filters.from_date) : null}
                   endDate={filters.to_date ? new Date(filters.to_date) : null}
                  //  maxDate={new Date()}
                   onChange={(update) => {
                     const [start, end] = update;
                    setFilters((prev) => ({
                      ...prev,
                      from_date: start ? moment(start).format("YYYY-MM-DD") : null,
                      to_date: end ? moment(end).format("YYYY-MM-DD") : null,
                    }));
                
                   }}
                   placeholderText="Select Custom Date"
                   dateFormat="dd/MM/yyyy"
                   className="date-picker-input"
                 />
               )}
             </div>
             </div>
                                    
                </div>
              </li>
              <li>
                <button className="btn red_button d-flex align-items-center" onClick={handleStatusClickToComplete} >
                  Complete
                </button>
              </li>
            </ul>
          </div>

          <div className="todoList_table">
            <div className="table-responsive">
              <Table>
                <thead className="table-dark">
                  <tr>
                    <th>Sr.No</th>
                    <th>Select</th>
                    <th>Title</th>
                    <th>Follow Up Date</th>
                    <th>RM</th>
                    <th>Channel Partner</th>
                    <th>Archive</th>
                  </tr>
                </thead>
                {todoList && todoList?.length > 0 ? (
                    <>
                <tbody>
                  {todoList.map((user, index) => (
                    <tr key={user.id}>
                      <td>{(currentPage - 1) * limit + index + 1}</td>
                      <td className="id-check"> 
                      <input
                        type="checkbox"
                        id={`check-${user.id}`}
                        checked={selectedIds.includes(user.id)}
                        onChange={() => handleStatusChange(user.id)}
                        disabled={!permissionscontext.edit}
                        className={`custom-checkbox ${!permissionscontext.edit ? 'no-cursor' : ''}`}
                      />
                    </td>
                      <td>
                        <div className="line_climb1">{capitalizeFirstLetter(user?.agenda)}</div>
                      </td>
                      <td>
                        {`${formatDateDMY(
                          user?.follow_up_date
                        )} at ${formatTime(user?.follow_up_time)}`}
                      </td>
                      <td className="textTransform">
                        {`${user?.relationship_manager_first_name} 
                          ${user?.relationship_manager_last_name} `}
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <p className="textTransform">{user?.channel_partner_name}</p>
                        </div>
                      </td>
                      <td>
                      <button
                        disabled={!permissionscontext.delete}
                        style={{
                          border: "none",
                          background: "transparent",
                          padding: 0,
                          cursor: !permissionscontext.delete
                            ? "not-allowed"
                            : "pointer",
                          opacity: !permissionscontext.delete
                            ? 0.5
                            : 1,
                        }}
                        onClick={() => {
                          setSelectedId(user.id);
                          setShow(true);
                        }}
                      >
                        <img
                          src="/images/cross.svg"
                          className="img-fluid"
                          alt="cross icon"
                        />
                      </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                </>
              ) : (
                    <>
                      <tbody>
                        <tr>
                          <td colSpan="6" className="border-0">
                            <div className="d-flex align-items-center justify-content-center mt-5">
                              <h4>Not Available</h4>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}
              </Table>
            </div>
          </div>
            <Archive
             show={show}
             handleClose={() => setShow(false)}
             handle={handleStatusCancel}
             />
          <ToastContainer />
          { count > 10 && (
          <Paginator
            currentPage={currentPage}
            totalPages={totalCount}
            onPageChange={handlePageChange}
          />
          )}
        </div>
      ) : (
        <Notauthorized />
      )}
    </>
  );
};

export default TodoList;
